export const LOGIN = "LOGIN";
export const LOGIN2FA = "LOGIN2FA";
export const LOGOUT = "LOGOUT";
export const TOGGLE_EDIT = "TOGGLE_EDIT";
export const SET_SERVICIOS = "SET_SERVICIOS";
export const SET_SERVICIOS_FAILED = "SET_SERVICIOS_FAILED";
export const SET_COMUNICACIONES = "SET_COMUNICACIONES";
export const SET_COMUNICACIONES_FAILED = "SET_COMUNICACIONES_FAILED";
export const INIT_SET_COMMON_DATA = "INIT_SET_COMMON_DATA";
export const SET_COMMON_DATA = "SET_COMMON_DATA";
export const SET_COMMON_DATA_FAILED = "SET_COMMON_DATA_FAILED";
export const INIT_UPDATE_USER_DATA = "INIT_UPDATE_USER_DATA";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const UPDATE_USER_DATA_FAILED = "UPDATE_USER_DATA_FAILED";
export const RESET_SUCCESS = "RESET_SUCCESS";
export const SET_ROLES = "SET_ROLES";
export const SET_ROLES_FAILED = "SET_ROLES_FAILED";
export const UPDATE_COMUNICACIONES = "UPDATE_COMUNICACIONES";
export const UPDATE_COMUNICACIONES_FAILED = "UPDATE_COMUNICACIONES_FAILED";
export const SET_CURRENT_COMMUNICATION = "SET_CURRENT_COMMUNICATION";
export const SET_PERSONA = "SET_PERSONA";
export const SET_PERSONA_FAILED = "SET_PERSONA_FAILED";
export const SET_RELACIONES = "SET_RELACIONES";
export const SET_RELACIONES_FAILED = "SET_RELACIONES_FAILED";
export const SET_LISTA_TERCEROS = "SET_LISTA_TERCEROS";
export const UPDATE_RELACIONES = "UPDATE_RELACIONES";
export const SET_REPRESENTADOS_POR_APP = "SET_REPRESENTADOS_POR_APP";
export const SET_SELECTED_SERVICIO = "SET_SELECTED_SERVICIO";
export const SET_CARPETA_REPRESENTADO_SELECCIONADO =
  "SET_CARPETA_REPRESENTADO_SELECCIONADO";
export const SET_VALIDACION_CUIL = "SET_VALIDACION_CUIL";
export const SET_SERVICIO_BUSCADO = "SET_SERVICIO_BUSCADO";
export const SET_ERROR_UPDATE_RDOS_LEGALES = "SET_ERROR_UPDATE_RDOS_LEGALES";
export const UPDATE_EMPLEADO = "UPDATE_EMPLEADO";
export const UPDATE_EMPLEADO_FAILED = "UPDATE_EMPLEADO_FAILED";
export const SET_CUILS = "SET_CUILS";
export const SET_LICENCIA_DOCUMENTS = "SET_LICENCIA_DOCUMENTS";
export const LOADING_START = "LOADING_START";
export const LOADING_END = "LOADING_END";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const UPDATE_CONFIGURACION2FA = "UPDATE_CONFIGURACION2FA";
export const UPDATE_CODIGO2FA = "UPDATE_CODIGO2FA";
export const UPDATE_VALIDACION_CODIGO2FA = "UPDATE_VALIDACION_CODIGO2FA";
export const SET_ADMIN_APPS = "SET_ADMIN_APPS";
export const SET_APPLICATION = "SET_APPLICATION";
export const TOGGLE_APPLICATION = "TOGGLE_APPLICATION";
export const SAVE_APPLICATION = "SAVE_APPLICATION";
export const SET_FAVORITOS = "SET_FAVORITOS";
export const RESET_CREDENTIALS = "RESET_CREDENTIALS";
export const SET_MODO_ADULTO_MAYOR = "SET_MODO_ADULTO_MAYOR";
export const SHOW_MISSING_DATA_POPUP = "SHOW_MISSING_DATA_POPUP";
export const HIDE_MISSING_DATA_POPUP = "HIDE_MISSING_DATA_POPUP";
export const SET_NOTIFICATION_TOKEN = "SET_NOTIFICATION_TOKEN";
export const UPDATE_NOTIFICATION_SETTINGS = "UPDATE_NOTIFICATION_SETTINGS";
export const UPDATE_NOTIFICATION_SETTINGS_FAILED = "UPDATE_NOTIFICATION_SETTINGS_FAILED";
export const INIT_UPDATE_NOTIFICATION_SETTINGS = "INIT_UPDATE_NOTIFICATION_SETTINGS";
